export const closeBalanceSheetViewer = viewer => ({
  type: "CLOSE_BALANCE_SHEET_VIEWER",
  viewer
});

export const openBalanceSheetViewer = viewer => ({
  type: "OPEN_BALANCE_SHEET_VIEWER",
  viewer
});

export const setBalanceSheetOrganization = organization => ({
  type: "SET_BALANCE_SHEET_ORGANIZATION",
  organization
});

export const setBalanceSheetModel = model => ({
  type: "SET_BALANCE_SHEET_MODEL",
  model
});

export const fetchBalanceSheet = data => ({
  type: "FETCH_BALANCE_SHEET",
  payload: data
});

export const initBalanceSheet = () => ({
  type: "INIT_BALANCE_SHEET"
});



// WEBPACK FOOTER //
// ./src/actions/actions/balance-sheet.js